import { render, staticRenderFns } from "./quotation-product-focus.vue?vue&type=template&id=0f7d2bd4"
import script from "./quotation-product-focus.vue?vue&type=script&lang=js"
export * from "./quotation-product-focus.vue?vue&type=script&lang=js"
import style0 from "./quotation-product-focus.vue?vue&type=style&index=0&id=0f7d2bd4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f7d2bd4')) {
      api.createRecord('0f7d2bd4', component.options)
    } else {
      api.reload('0f7d2bd4', component.options)
    }
    module.hot.accept("./quotation-product-focus.vue?vue&type=template&id=0f7d2bd4", function () {
      api.rerender('0f7d2bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-product-focus.vue"
export default component.exports